module.exports = __webpack_public_path__ + "static/media/slider_bg_3.c6f5fe33.jpg";